var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(_vm.loading)?_c('PageLoader'):[_c('navbar',{class:_vm.$i18n.locale === 'ar' ? 'arabic' : 'english'}),_c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('router-view',{class:_vm.$i18n.locale === 'ar' ? 'arabic' : 'english'})],1),_c('m-footer',{class:_vm.$i18n.locale === 'ar' ? 'arabic' : 'english'})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }